import _ from 'lodash';
import companyApi from '@/api/companyApi';
import { fetchOnce } from '@/store/utils/fetchOnce';
import config from '@/config/env-constants';

export default {
	namespace: true,

	state: {
		companies: {},
		connectedCompanies: {},
		currCompany: {},
		regions: {},
		areas: {},
		regionsLoaded: false,
		areasLoaded: false,
		companiesLoaded: false,
		connectedCompaniesLoaded: false,
	},

	mutations: {
		SET_ALL_COMPANIES(state, companies) {
			state.companies = companies;
		},
		SET_CONNECTED_COMPANIES(state, companies) {
			state.connectedCompanies = companies;
		},
		SET_CURR_COMPANY(state, company) {
			state.currCompany = company;
		},

		SET_ALL_REGIONS(state, regions) {
			state.regions = regions;
		},
		SET_ALL_AREAS(state, areas) {
			state.areas = areas;
		},
		SET_REGIONS_LOADED(state, val) {
			state.regionsLoaded = val;
		},
		SET_AREAS_LOADED(state, val) {
			state.areasLoaded = val;
		},
		SET_COMPANIES_LOADED(state, val) {
			state.companiesLoaded = val;
		},
		SET_CONNECTED_COMPANIES_LOADED(state, val) {
			state.connectedCompaniesLoaded = val;
		},
	},

	actions: {
		setAllCompanies(vuexContext, companies) {
			vuexContext.commit('SET_ALL_COMPANIES', companies);
		},
		setAllConnectedCompanies(vuexContext, companies) {
			vuexContext.commit('SET_CONNECTED_COMPANIES', companies);
		},
		updateAllCompanies(vuexContext, newCompanies) {
			let companies = vuexContext.getters.companies;

			_.forEach(newCompanies, (value, key) => {
				companies[key] = value;
			});

			vuexContext.commit('SET_ALL_COMPANIES', companies);
		},
		setAllRegions(vuexContext, regions) {
			vuexContext.commit('SET_ALL_REGIONS', regions);
		},

		setAllAreas(vuexContext, areas) {
			vuexContext.commit('SET_ALL_AREAS', areas);
		},

		fetchRegionsIfNeeded({ state, commit }, { currUserId }) {
			if (state.regionsLoaded) return Promise.resolve();
			return fetchOnce('regions', () =>
				companyApi.getRegions(currUserId).then(({ data }) => {
					if (data.isSuccess) {
						commit('SET_ALL_REGIONS', data.regions);
						commit('SET_REGIONS_LOADED', true);
					}
					return data;
				})
			);
		},

		fetchAreasIfNeeded({ state, commit }, { currUserId }) {
			if (state.areasLoaded) return Promise.resolve();
			return fetchOnce('areas', () =>
				companyApi.getAreas(currUserId).then(({ data }) => {
					if (data.isSuccess) {
						commit('SET_ALL_AREAS', data.areas);
						commit('SET_AREAS_LOADED', true);
					}
					return data;
				})
			);
		},
		updateAllConnectedCompanies(vuexContext, newCompanies) {
			let companies = vuexContext.getters.connectedCompanies;

			_.forEach(newCompanies, (value, key) => {
				companies[key] = value;
			});

			vuexContext.commit('SET_CONNECTED_COMPANIES', companies);
		},

		fetchCompaniesIfNeeded({ state, getters, commit }, payload = {}) {
			if (state.companiesLoaded) return Promise.resolve();
			return fetchOnce('companies', () => {
				let currUserId = payload.currUserId || getters.loggedUser.id;
				let view = payload.view || (getters.isSuperAdmin ? config.view.ADMIN : config.view.COMPANY);
				let filterBy = payload.filterBy || {
					companyId: getters.loggedUserCompany.id,
					companyAccess: getters.loggedUser.companyAccess,
					includeConnection: true
				};

				return companyApi.getCompanies(filterBy, view, currUserId).then(({ data }) => {
					if (data.isSuccess) {
						commit('SET_ALL_COMPANIES', data.companies);
						commit('SET_COMPANIES_LOADED', true);

						if (!_.isEmpty(data.connectedCompanies)) {
							commit('SET_CONNECTED_COMPANIES', data.connectedCompanies);
							commit('SET_CONNECTED_COMPANIES_LOADED', true);
						}
					}
					return data;
				});
			});
		}
	},

	getters: {
		companies(state) {
			if (!_.isEmpty(state.companies)) {
				return state.companies;
			}
			return {};
		},
		connectedCompanies(state) {
			if (!_.isEmpty(state.connectedCompanies)) {
				return state.connectedCompanies;
			}
			return {};
		},
		currCompany(state) {
			if (!_.isEmpty(state.currCompany)) {
				return state.currCompany;
			}
			return {};
		},
		regions(state) {
			if (!_.isEmpty(state.regions)) {
				return state.regions;
			}
			return {};
		},
		areas(state) {
			if (!_.isEmpty(state.areas)) {
				return state.areas;
			}
			return {};
		},
	}
}
